import { useEffect, useMemo } from 'react';
import { FieldError, FieldValues, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { getRules } from '@steelbuy/ui-domain';
import { MaterialSelection, MaterialSelectionProps, OTHER } from './MaterialSelection';

const otherInputName = 'coatingColourValue';

export const CoatingColourSelection = <TFieldValues extends FieldValues = FieldValues>({
    material,
    name,
    control,
    rules,
    error,
    getOptions,
    label,
}: MaterialSelectionProps<TFieldValues>) => {
    const {
        watch,
        trigger,
        setValue,
        formState: { errors },
    } = useFormContext();
    const options = getOptions(material).slice().sort();
    const { t } = useTranslation(['uiDomain', 'domainModel']);
    const validationRules = getRules(t);
    const otherRules = useMemo(
        () => ({
            ...validationRules.required(),
            pattern: {
                value: /^[a-zA-Z ]+$/,
                message: t('uiDomain:validation.letterValue'),
            },
        }),
        []
    );

    useEffect(() => {
        const value = watch(name);
        if (!options.length && value !== undefined && watch('coating') !== undefined) {
            setValue(name, undefined);
            setValue(otherInputName, '');
            trigger(name);
        } else if (options.length && value !== undefined && value !== OTHER && !options.includes(value)) {
            setValue(name, OTHER);
            setValue(otherInputName, value);
        }
    }, [watch('coating')]);

    return (
        <MaterialSelection
            material={material}
            name={name}
            control={control}
            rules={rules}
            error={error}
            getOptions={getOptions}
            label={label}
            allowOtherInput
            otherInputName={otherInputName}
            otherError={errors?.[otherInputName] as FieldError}
            otherInputType="text"
            otherRules={otherRules}
        />
    );
};
